import { render, staticRenderFns } from "./ListTermAndConditionView.vue?vue&type=template&id=606a1548&"
import script from "./ListTermAndConditionView.vue?vue&type=script&lang=js&"
export * from "./ListTermAndConditionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports